import {
  GameMode,
  LanguageCode,
  MediaType,
  QuestionImageRevealEffectType,
  QuestionPinTolerance,
  QuestionRangeAnswerMargin,
  QuestionType,
  QuizCategory,
  QuizVisibility,
} from '@klurigo/common'

export const GameModeLabels: { [key in GameMode]: string } = {
  [GameMode.Classic]: 'Classic',
  [GameMode.ZeroToOneHundred]: '0 to 100',
}

export const LanguageLabels: { [key in LanguageCode]: string } = {
  [LanguageCode.Abkhaz]: 'Abkhaz',
  [LanguageCode.Afar]: 'Afar',
  [LanguageCode.Afrikaans]: 'Afrikaans',
  [LanguageCode.Akan]: 'Akan',
  [LanguageCode.Albanian]: 'Albanian',
  [LanguageCode.Amharic]: 'Amharic',
  [LanguageCode.Arabic]: 'Arabic',
  [LanguageCode.Aragonese]: 'Aragonese',
  [LanguageCode.Armenian]: 'Armenian',
  [LanguageCode.Assamese]: 'Assamese',
  [LanguageCode.Avaric]: 'Avaric',
  [LanguageCode.Avestan]: 'Avestan',
  [LanguageCode.Aymara]: 'Aymara',
  [LanguageCode.Azerbaijani]: 'Azerbaijani',
  [LanguageCode.Bambara]: 'Bambara',
  [LanguageCode.Bashkir]: 'Bashkir',
  [LanguageCode.Basque]: 'Basque',
  [LanguageCode.Belarusian]: 'Belarusian',
  [LanguageCode.Bengali]: 'Bengali',
  [LanguageCode.Bihari]: 'Bihari',
  [LanguageCode.Bislama]: 'Bislama',
  [LanguageCode.Bosnian]: 'Bosnian',
  [LanguageCode.Breton]: 'Breton',
  [LanguageCode.Bulgarian]: 'Bulgarian',
  [LanguageCode.Burmese]: 'Burmese',
  [LanguageCode.Catalan]: 'Catalan',
  [LanguageCode.Chamorro]: 'Chamorro',
  [LanguageCode.Chechen]: 'Chechen',
  [LanguageCode.Chichewa]: 'Chichewa',
  [LanguageCode.Chinese]: 'Chinese',
  [LanguageCode.ChurchSlavonic]: 'Church Slavonic',
  [LanguageCode.Chuvash]: 'Chuvash',
  [LanguageCode.Cornish]: 'Cornish',
  [LanguageCode.Corsican]: 'Corsican',
  [LanguageCode.Cree]: 'Cree',
  [LanguageCode.Croatian]: 'Croatian',
  [LanguageCode.Czech]: 'Czech',
  [LanguageCode.Danish]: 'Danish',
  [LanguageCode.Dhivehi]: 'Dhivehi',
  [LanguageCode.Dutch]: 'Dutch',
  [LanguageCode.Dzongkha]: 'Dzongkha',
  [LanguageCode.English]: 'English',
  [LanguageCode.Esperanto]: 'Esperanto',
  [LanguageCode.Estonian]: 'Estonian',
  [LanguageCode.Ewe]: 'Ewe',
  [LanguageCode.Faroese]: 'Faroese',
  [LanguageCode.Fijian]: 'Fijian',
  [LanguageCode.Finnish]: 'Finnish',
  [LanguageCode.French]: 'French',
  [LanguageCode.Fula]: 'Fula',
  [LanguageCode.Galician]: 'Galician',
  [LanguageCode.Ganda]: 'Ganda',
  [LanguageCode.Georgian]: 'Georgian',
  [LanguageCode.German]: 'German',
  [LanguageCode.Greek]: 'Greek',
  [LanguageCode.Guarani]: 'Guarani',
  [LanguageCode.Gujarati]: 'Gujarati',
  [LanguageCode.Haitian]: 'Haitian',
  [LanguageCode.Hausa]: 'Hausa',
  [LanguageCode.Hebrew]: 'Hebrew',
  [LanguageCode.Herero]: 'Herero',
  [LanguageCode.Hindi]: 'Hindi',
  [LanguageCode.HiriMotu]: 'Hiri Motu',
  [LanguageCode.Hungarian]: 'Hungarian',
  [LanguageCode.Icelandic]: 'Icelandic',
  [LanguageCode.Ido]: 'Ido',
  [LanguageCode.Igbo]: 'Igbo',
  [LanguageCode.Indonesian]: 'Indonesian',
  [LanguageCode.Interlingua]: 'Interlingua',
  [LanguageCode.Interlingue]: 'Interlingue',
  [LanguageCode.Inuktitut]: 'Inuktitut',
  [LanguageCode.Inupiaq]: 'Inupiaq',
  [LanguageCode.Irish]: 'Irish',
  [LanguageCode.Italian]: 'Italian',
  [LanguageCode.Japanese]: 'Japanese',
  [LanguageCode.Javanese]: 'Javanese',
  [LanguageCode.Kalaallisut]: 'Kalaallisut',
  [LanguageCode.Kannada]: 'Kannada',
  [LanguageCode.Kanuri]: 'Kanuri',
  [LanguageCode.Kashmiri]: 'Kashmiri',
  [LanguageCode.Kazakh]: 'Kazakh',
  [LanguageCode.Khmer]: 'Khmer',
  [LanguageCode.Kikuyu]: 'Kikuyu',
  [LanguageCode.Kinyarwanda]: 'Kinyarwanda',
  [LanguageCode.Kirundi]: 'Kirundi',
  [LanguageCode.Komi]: 'Komi',
  [LanguageCode.Kongo]: 'Kongo',
  [LanguageCode.Korean]: 'Korean',
  [LanguageCode.Kurdish]: 'Kurdish',
  [LanguageCode.Kwanyama]: 'Kwanyama',
  [LanguageCode.Kyrgyz]: 'Kyrgyz',
  [LanguageCode.Lao]: 'Lao',
  [LanguageCode.Latin]: 'Latin',
  [LanguageCode.Latvian]: 'Latvian',
  [LanguageCode.Limburgish]: 'Limburgish',
  [LanguageCode.Lingala]: 'Lingala',
  [LanguageCode.Lithuanian]: 'Lithuanian',
  [LanguageCode.LubaKatanga]: 'Luba-Katanga',
  [LanguageCode.Luxembourgish]: 'Luxembourgish',
  [LanguageCode.Macedonian]: 'Macedonian',
  [LanguageCode.Malagasy]: 'Malagasy',
  [LanguageCode.Malay]: 'Malay',
  [LanguageCode.Malayalam]: 'Malayalam',
  [LanguageCode.Maltese]: 'Maltese',
  [LanguageCode.Manx]: 'Manx',
  [LanguageCode.Maori]: 'Maori',
  [LanguageCode.Marathi]: 'Marathi',
  [LanguageCode.Marshallese]: 'Marshallese',
  [LanguageCode.Mongolian]: 'Mongolian',
  [LanguageCode.Nauru]: 'Nauru',
  [LanguageCode.Navajo]: 'Navajo',
  [LanguageCode.Ndonga]: 'Ndonga',
  [LanguageCode.Nepali]: 'Nepali',
  [LanguageCode.NorthernNdebele]: 'Northern Ndebele',
  [LanguageCode.NorthernSami]: 'Northern Sami',
  [LanguageCode.NorwegianBokmal]: 'Norwegian Bokmål',
  [LanguageCode.NorwegianNynorsk]: 'Norwegian Nynorsk',
  [LanguageCode.Nuosu]: 'Nuosu',
  [LanguageCode.Occitan]: 'Occitan',
  [LanguageCode.Ojibwe]: 'Ojibwe',
  [LanguageCode.Oriya]: 'Oriya',
  [LanguageCode.Oromo]: 'Oromo',
  [LanguageCode.Ossetian]: 'Ossetian',
  [LanguageCode.Pali]: 'Pali',
  [LanguageCode.Pashto]: 'Pashto',
  [LanguageCode.Persian]: 'Persian',
  [LanguageCode.Polish]: 'Polish',
  [LanguageCode.Portuguese]: 'Portuguese',
  [LanguageCode.Punjabi]: 'Punjabi',
  [LanguageCode.Quechua]: 'Quechua',
  [LanguageCode.Romanian]: 'Romanian',
  [LanguageCode.Romansh]: 'Romansh',
  [LanguageCode.Russian]: 'Russian',
  [LanguageCode.Samoan]: 'Samoan',
  [LanguageCode.Sango]: 'Sango',
  [LanguageCode.Sanskrit]: 'Sanskrit',
  [LanguageCode.Sardinian]: 'Sardinian',
  [LanguageCode.ScottishGaelic]: 'Scottish Gaelic',
  [LanguageCode.Serbian]: 'Serbian',
  [LanguageCode.Shona]: 'Shona',
  [LanguageCode.Sindhi]: 'Sindhi',
  [LanguageCode.Sinhala]: 'Sinhala',
  [LanguageCode.Slovak]: 'Slovak',
  [LanguageCode.Slovene]: 'Slovene',
  [LanguageCode.Somali]: 'Somali',
  [LanguageCode.SouthernNdebele]: 'Southern Ndebele',
  [LanguageCode.SouthernSotho]: 'Southern Sotho',
  [LanguageCode.Spanish]: 'Spanish',
  [LanguageCode.Sundanese]: 'Sundanese',
  [LanguageCode.Swahili]: 'Swahili',
  [LanguageCode.Swati]: 'Swati',
  [LanguageCode.Swedish]: 'Swedish',
  [LanguageCode.Tagalog]: 'Tagalog',
  [LanguageCode.Tahitian]: 'Tahitian',
  [LanguageCode.Tajik]: 'Tajik',
  [LanguageCode.Tamil]: 'Tamil',
  [LanguageCode.Tatar]: 'Tatar',
  [LanguageCode.Telugu]: 'Telugu',
  [LanguageCode.Thai]: 'Thai',
  [LanguageCode.Tibetan]: 'Tibetan',
  [LanguageCode.Tigrinya]: 'Tigrinya',
  [LanguageCode.Tongan]: 'Tongan',
  [LanguageCode.Tsonga]: 'Tsonga',
  [LanguageCode.Tswana]: 'Tswana',
  [LanguageCode.Turkish]: 'Turkish',
  [LanguageCode.Turkmen]: 'Turkmen',
  [LanguageCode.Twi]: 'Twi',
  [LanguageCode.Uighur]: 'Uighur',
  [LanguageCode.Ukrainian]: 'Ukrainian',
  [LanguageCode.Urdu]: 'Urdu',
  [LanguageCode.Uzbek]: 'Uzbek',
  [LanguageCode.Venda]: 'Venda',
  [LanguageCode.Vietnamese]: 'Vietnamese',
  [LanguageCode.Volapuk]: 'Volapük',
  [LanguageCode.Walloon]: 'Walloon',
  [LanguageCode.Welsh]: 'Welsh',
  [LanguageCode.WestFrisian]: 'West Frisian',
  [LanguageCode.Wolof]: 'Wolof',
  [LanguageCode.Xhosa]: 'Xhosa',
  [LanguageCode.Yiddish]: 'Yiddish',
  [LanguageCode.Yoruba]: 'Yoruba',
  [LanguageCode.Zhuang]: 'Zhuang',
  [LanguageCode.Zulu]: 'Zulu',
}

export const QuizVisibilityLabels: { [key in QuizVisibility]: string } = {
  [QuizVisibility.Public]: 'Public',
  [QuizVisibility.Private]: 'Private',
}

export const QuizCategoryLabels: { [key in QuizCategory]: string } = {
  [QuizCategory.GeneralKnowledge]: 'General Knowledge',
  [QuizCategory.Science]: 'Science',
  [QuizCategory.History]: 'History',
  [QuizCategory.Geography]: 'Geography',
  [QuizCategory.Entertainment]: 'Entertainment',
  [QuizCategory.Sports]: 'Sports',
  [QuizCategory.Literature]: 'Literature',
  [QuizCategory.Technology]: 'Technology',
  [QuizCategory.Art]: 'Art',
  [QuizCategory.Music]: 'Music',
  [QuizCategory.Film]: 'Film',
  [QuizCategory.FoodAndDrink]: 'Food & Drink',
  [QuizCategory.Politics]: 'Politics',
  [QuizCategory.Mythology]: 'Mythology',
  [QuizCategory.Nature]: 'Nature',
  [QuizCategory.Business]: 'Business',
  [QuizCategory.Health]: 'Health',
  [QuizCategory.Religion]: 'Religion',
  [QuizCategory.Space]: 'Space',
  [QuizCategory.Mathematics]: 'Mathematics',
  [QuizCategory.Other]: 'Other',
}

export const QuestionTypeLabels: { [key in QuestionType]: string } = {
  [QuestionType.MultiChoice]: 'Multiple choice',
  [QuestionType.Range]: 'Range',
  [QuestionType.TrueFalse]: 'True or false',
  [QuestionType.TypeAnswer]: 'Type answer',
  [QuestionType.Pin]: 'Pin',
  [QuestionType.Puzzle]: 'Puzzle',
}

export const QuestionRangeAnswerMarginLabels: {
  [key in QuestionRangeAnswerMargin]: string
} = {
  [QuestionRangeAnswerMargin.None]: 'None',
  [QuestionRangeAnswerMargin.Low]: 'Low',
  [QuestionRangeAnswerMargin.Medium]: 'Medium',
  [QuestionRangeAnswerMargin.High]: 'High',
  [QuestionRangeAnswerMargin.Maximum]: 'Maximum',
}

export const QuestionPinToleranceLabels: {
  [key in QuestionPinTolerance]: string
} = {
  [QuestionPinTolerance.Low]: 'Low',
  [QuestionPinTolerance.Medium]: 'Medium',
  [QuestionPinTolerance.High]: 'High',
  [QuestionPinTolerance.Maximum]: 'Maximum',
}

export const MediaTypeLabels: { [key in MediaType]: string } = {
  [MediaType.Image]: 'Image',
  [MediaType.Audio]: 'Audio',
  [MediaType.Video]: 'Video',
}

export const ImageRevealEffectLabels: {
  [key in QuestionImageRevealEffectType]: string
} = {
  [QuestionImageRevealEffectType.Blur]: 'Blur',
  [QuestionImageRevealEffectType.Square3x3]: 'Square 3x3',
  [QuestionImageRevealEffectType.Square5x5]: 'Square 5x5',
  [QuestionImageRevealEffectType.Square8x8]: 'Square 8x8',
}
